interface Props {
  arrowColor: string
  className?: string
  onClick?: () => void
}

export const RefreshIcon = ({ arrowColor, className, onClick }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="15 15 12 12"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M16.3285 23.7337C16.7909 24.2847 17.3286 24.713 17.9418 25.0185C18.5549 25.324 19.1891 25.5054 19.8444 25.5627C20.4997 25.6201 21.1558 25.5515 21.8127 25.3571C22.4696 25.1627 23.0735 24.8344 23.6245 24.372L22.8848 23.4905C22.0252 24.2117 21.0449 24.5242 19.9437 24.4278C18.8426 24.3315 17.9314 23.8535 17.2101 22.994C16.4889 22.1344 16.1764 21.1541 16.2728 20.0529C16.3691 18.9518 16.847 18.0406 17.7066 17.3193C18.5661 16.5981 19.5465 16.2856 20.6476 16.382C21.7488 16.4783 22.66 16.9562 23.3813 17.8158L23.4367 17.8819L22.1802 17.772L22.0589 18.9254L25.3015 19.2091L25.5852 15.9664L24.4283 15.8856L24.3183 17.1422L24.2628 17.0761C23.8005 16.5251 23.2628 16.0968 22.6496 15.7913C22.0365 15.4858 21.4022 15.3044 20.7469 15.247C20.0917 15.1897 19.4356 15.2582 18.7787 15.4526C18.1218 15.647 17.5178 15.9754 16.9669 16.4377C16.4159 16.9001 15.9876 17.4378 15.6821 18.051C15.3766 18.6641 15.1952 19.2983 15.1378 19.9536C15.0805 20.6089 15.149 21.265 15.3434 21.9219C15.5378 22.5788 15.8662 23.1827 16.3285 23.7337Z"
        fill={arrowColor}
      />
    </svg>
  )
}
